import {
  SET_IS_LOADING_ROLES,
  ADD_PROVIDER_ROLES,
  SET_SELECTED_ROLE,
} from "./types";

export const setIsLoadingRoles = payload => {
  return { type: SET_IS_LOADING_ROLES, payload };
};

export const addProviderRoles = payload => {
  return { type: ADD_PROVIDER_ROLES, payload };
};

export const setSelectedRole = payload => {
  return { type: SET_SELECTED_ROLE, payload };
};
